/*-------------------------copy-link-btn------------------------------*/
export const handleCopyLinkBthClick = () => {
    $('.copy-post-link-btn').on('click', function () {
		const sp = $('#post-share');
		sp.focus();
		sp.select();
		document.execCommand('copy');
		$('.copy-link-icon').fadeOut(600).fadeIn(800);
		$('.copyed-link-icon').fadeIn(600).fadeOut(800);
	});
}